import React, { useState } from "react";
import "./signup.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // Do something with the email and password values
  };

  return (
    <div className="form sign-in">
      <h2>Welcome back,</h2>
      <form onSubmit={handleSubmit}>
        <label>
          <span>Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label>
          <span>Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <p className="forgot-pass">Forgot password?</p>
        <button type="submit" className="submit">
          Sign In
        </button>
        <button type="button" className="fb-btn">
          Connect with <span>facebook</span>
        </button>
      </form>
    </div>
  );
}
export default Login;

 export function SignUpForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // Do something with the name, email, and password values
  };

  return (
    <div className="form sign-up">
      <h2>Time to feel like home,</h2>
      <form onSubmit={handleSubmit}>
        <label>
          <span>Name</span>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </label>
        <label>
          <span>Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label>
          <span>Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <button type="submit" className="submit">
          Sign Up
        </button>
        <button type="button" className="fb-btn">
          Join with <span>facebook</span>
        </button>
      </form>
    </div>
  );
}

 export function SignUpContainer() {
  const [isSignUp, setIsSignUp] = useState(false);

  const handleClick = () => {
    setIsSignUp(!isSignUp);
  };

  return (
    <div className="cont">
      {isSignUp ? <SignUpForm /> : <Login />}
      <div className="sub-cont">
        <div className="img">
          <div className="img__text m--up">
            <h2>New here?</h2>
            <p>Sign up and discover great amount of new opportunities!</p>
          </div>
          <div className="img__text m--in">
            <h2>One of us?</h2>
            <p>If you already has an account, just sign in. We've missed you!</p>
          </div>
          <div className="img__btn">
            <span className={isSignUp ? "" : "m--up"} onClick={handleClick}>
              Sign In
            </span>
            <span className={isSignUp ? "m--up" : ""} onClick={handleClick}>
              Sign Up
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}


